function getRelativePos(elm){
    let pPos = elm.parentNode.getBoundingClientRect(), // parent pos
        cPos = elm.getBoundingClientRect(), // target pos
        pos = {};

    pos.top    = cPos.top    - pPos.top + elm.parentNode.scrollTop,
        pos.right  = cPos.right  - pPos.right,
        pos.bottom = cPos.bottom - pPos.bottom,
        pos.left   = cPos.left   - pPos.left;

    return pos;
}

function scrollTo(element, to, duration, onDone) {
    let start = element.scrollTop,
        change = to - start,
        startTime = performance.now(),
        now, elapsed, t;

    function animateScroll(){
        now = performance.now();
        elapsed = (now - startTime)/1000;
        t = (elapsed/duration);

        element.scrollLeft = start + change * easeInOutQuad(t);

        if( t < 1 )
            window.requestAnimationFrame(animateScroll);
        else
            onDone && onDone();
    }

    animateScroll();
}

function scrollVTo(element, to, duration, onDone) {
    let start = element.scrollTop,
        change = to - start,
        startTime = performance.now(),
        now, elapsed, t;

    function animateScroll(){
        now = performance.now();
        elapsed = (now - startTime)/1000;
        t = (elapsed/duration);

        element.scrollTop = start + change * easeInOutQuad(t);

        if( t < 1 )
            window.requestAnimationFrame(animateScroll);
        else
            onDone && onDone();
    }

    animateScroll();
}

function easeInOutQuad(t){ return t<.5 ? 2*t*t : -1+(4-2*t)*t }

export default {
    toElement (container, elm, duration){
        let pos = getRelativePos(elm);
        scrollTo( container, pos.left , duration);  // duration in seconds
    },

    toVElement (container, elm, duration, onDone){
        let pos = getRelativePos(elm);
        scrollVTo( container, pos.top , duration, onDone);  // duration in seconds
    },

    menuIndex (scroll, scrollTargets) {
        let minDiff  = 10000000;
        let menuIndex = -1;

        for (let index = 0; index < scrollTargets.length; index ++) {
            const element = document.querySelector(scrollTargets[index]);

            const pos = getRelativePos(element);
            const diff = Math.abs(pos.top - scroll.scrollTop);

            if (diff < minDiff) {
                minDiff = diff;
                menuIndex = index;
            }
        }

        if (menuIndex === scrollTargets.length-2 && scrollTargets.length > 1) {
            const element1 = document.querySelector(scrollTargets[scrollTargets.length-1]);
            const element2 = document.querySelector(scrollTargets[scrollTargets.length-2]);

            const pos1 = getRelativePos(element1);
            const pos2 = getRelativePos(element2);

            if (pos1.top - scroll.scrollTop > 0 && pos2.top - scroll.scrollTop < 0) {
                menuIndex = scrollTargets.length - 1;
            }
        }

        return menuIndex;
    },
}